import {BankAccount} from '../model/bank-account';
import {HttpClient} from '@angular/common/http';
import {ConfigService} from './config.service';
import {Injectable} from '@angular/core';

@Injectable()
export class BankAccountService {
    constructor(private httpClient: HttpClient, private configService: ConfigService) {
    }

    public async create(bankAccount: BankAccount): Promise<BankAccount> {
        const url = this.configService.baseUrl() + '/bank-account';
        return await this.httpClient.post<BankAccount>(url, bankAccount).toPromise();
    }

    public async get(bankAccountId: string): Promise<BankAccount> {
        const url = this.configService.baseUrl() + '/bank-account';
        return await this.httpClient.get<BankAccount>(`${url}/${bankAccountId}`).toPromise();
    }

    public async update(bankAccount: BankAccount): Promise<void> {
        const url = this.configService.baseUrl() + '/bank-account';
        await this.httpClient.put<BankAccount>(`${url}/${bankAccount._id}`, bankAccount).toPromise();
    }

    public async getBankAccountById(accountId: string): Promise<BankAccount> {
        const url = `${this.configService.baseUrl()}bank-account/${accountId}`;
        return await this.httpClient.get<BankAccount>(url).toPromise();
    }
}
